import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { BoardState } from './types';
import { initialState } from './initialState';
import {
  createFetchBoards,
  createCreateBoard,
  createJoinBoard,
  createFetchBoard,
  createUpdateBoard,
  createLockBoard,
  createUnlockBoard,
  createPublishBoard,
  createUnpublishBoard,
  createCompleteBoard,
  createRandomizeNumbers,
  createInviteParticipant,
} from './actions';

const createBoardStore: StateCreator<BoardState, [['zustand/devtools', never]]> = (set) => ({
  ...initialState,

  // Board List Actions
  fetchBoards: createFetchBoards(set),
  createBoard: createCreateBoard(set),
  joinBoard: createJoinBoard(set),

  // Single Board Actions
  fetchBoard: createFetchBoard(set),
  updateBoard: createUpdateBoard(set),
  lockBoard: createLockBoard(set),
  unlockBoard: createUnlockBoard(set),
  publishBoard: createPublishBoard(set),
  unpublishBoard: createUnpublishBoard(set),
  completeBoard: createCompleteBoard(set),
  randomizeNumbers: createRandomizeNumbers(set),
  inviteParticipant: createInviteParticipant(),

  // Utilities
  setCurrentBoard: (board) => {
    set({ currentBoard: board });
  },

  clearError: () => {
    set({ error: null });
  },

  reset: () => {
    set(initialState);
  },
});

export const useBoardStore = create<BoardState>()(
  devtools(createBoardStore, { name: 'board-store' })
);

// Re-export types and selectors
export type { BoardState } from './types';
export {
  selectBoards,
  selectCurrentBoard,
  selectIsLoading,
  selectIsLoadingBoard,
  selectError,
  selectBoardById,
  selectIsManager,
  selectBoardStatus,
} from './selectors';
